import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';

import {
  getContentAlignment,
  getTextAlignment,
  visibilityControl,
} from '../../Card.styles';

export const Wrapper = styled(Flex)<
  Pick<
    ContentfulCardFragment,
    | 'contentAlignment'
    | 'mediaAnimationEffect'
    | 'visibleInDesktop'
    | 'visibleInMobile'
  > & {
    $hasBackgroundImage: boolean;
  }
>`
  position: relative;
  overflow: hidden;
  width: 100%;
  ${({ visibleInDesktop, visibleInMobile }) => css`
    ${visibilityControl(visibleInDesktop, visibleInMobile)}
  `};

  ${({
    $hasBackgroundImage,
    contentAlignment,
    mediaAnimationEffect,
    theme,
  }) => css`
    ${mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}

    padding: ${theme.spacing(5, 2)};
    color: ${$hasBackgroundImage ? theme.colors.white : theme.colors.black};

    ${theme.media.md.up} {
      padding: ${({ theme }) => theme.spacing(6)} 5%;
      ${getContentAlignment(contentAlignment)};
    }

    ${theme.media.lg.up} {
      padding-inline: 10%;
    }

    ${theme.media.md.down} {
      ${getContentAlignment(contentAlignment)}
    }
  `};
`;

export const Content = styled(Flex)<
  Pick<ContentfulCardFragment, 'textAlignment'>
>`
  flex-direction: column;
  word-break: break-word;
  white-space: pre-wrap;
  z-index: 2;
  justify-content: center;
  ${({ textAlignment, theme }) => css`
    font-size: ${theme.fontSizes.p2};
    ${getTextAlignment(textAlignment)}
    ${theme.media.md.down} {
      width: 100%;
      margin: 0 auto;
    }
    ${theme.media.md.up} {
      max-width: 800px;
    }
  `}
`;

export const MediaBox = styled(Box)<{
  $backgroundAlignment?: string | null;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  position: absolute;
  div {
    height: 100%;
  }
  img,
  video {
    object-fit: cover;
  }

  ${({ $backgroundAlignment, theme }) => css`
    ${theme.media.md.down} {
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;
